import { MsChevron } from '@sunrise/icons'
import { MsHeadline, MsText } from '@sunrise/components'
import { Cms } from '@sunrise/types'
import { computed, defineComponent, onMounted, onUnmounted, PropType, ref } from 'vue'
import M_ChannelTeaser from '../../M_ChannelTeaser/M_ChannelTeaser.vue'
import MsCircle from './circle_stage_home.svg?component'
import { MChannelStageServiceData } from '../M_Channel_Stage.interfaces'
import WeatherModule from '../WeatherModule/WeatherModule.vue'
import { inViewDetector, allContentByLabel, contentByLabel, screenSizeDetection } from '@sunrise/shared'
import { scrollTo } from '../../../../ts/utils/scrollUtils'

export default defineComponent({
    name: 'HydratedChannelStage',
    components: {
        MsText,
        MsHeadline,
        M_ChannelTeaser,
        MsChevron,
        MsCircle,
        WeatherModule,
    },
    props: {
        cmsContent: {
            type: Object as PropType<Cms.Content<MChannelStageServiceData>>,
            required: true,
        },
        headline: Array as PropType<Cms.ContentTag[]>,
    },

    setup(props) {
        const { isScreenM, isScreenL, isScreenXXL } = screenSizeDetection()
        const description = contentByLabel(props.cmsContent, 'description')
        const channelTeasers = allContentByLabel(props.cmsContent, 'M_ChannelTeaser')
        const currentIndex = ref(0)
        const showNext = computed(() => currentIndex.value <= 1 && !isLastTeaserIntersecting.value)
        const isLastTeaserIntersecting = ref<boolean>(false)
        const teaserRefs = ref<Array<ReturnType<typeof defineComponent>>>([])
        const teaserContainerRef = ref<HTMLDivElement>()
        const showButtons = computed(() => isScreenM.value && !isScreenL.value)

        let localInViewDetector: ReturnType<typeof inViewDetector.createObserver>

        onMounted(() => {
            localInViewDetector = inViewDetector.createObserver({
                root: teaserContainerRef.value,
                threshold: 1.0,
                allEvents: true,
            })

            localInViewDetector.observe(teaserRefs.value[2].$el as HTMLElement, (entry) => {
                isLastTeaserIntersecting.value = entry.isIntersecting
            })
        })

        onUnmounted(() => localInViewDetector.kill())

        const next = () => {
            currentIndex.value = teaserRefs.value.length - 1
            const teaserContainer = teaserContainerRef.value
            const position = teaserContainer?.scrollWidth

            scrollTo(teaserContainer as Element, {
                left: position,
                behavior: 'smooth',
            })
        }

        const prev = () => {
            currentIndex.value = 0
            const teaserContainer = teaserContainerRef.value
            scrollTo(teaserContainer as Element, {
                left: 0,
                behavior: 'smooth',
            })
        }

        return {
            description,
            channelTeasers,
            next,
            prev,
            currentIndex,
            showNext,
            teaserRefs,
            showButtons,
            isScreenL,
            isScreenXXL,
            teaserContainerRef,
        }
    },
})
